import axios from "axios"
// 使用当前的store
import store from "./store"
import router from "./router"
import Vue from "vue"
import $ from "jquery"
import qs from "qs"
import { getErrorMessage } from "../src/utils/errorMessageMap"
let instance = axios
// http request拦截器
instance.interceptors.request.use(
  config => {
    if (process.env.VUE_APP_IS_MIRROR) {
      const noPre = ["engine2/", "plugs_v2/", "app/", "sso/"]
      if (noPre.some(item => config.url.indexOf(item) > -1)) {
        config.url = window.location.origin + "/" + config.url
      } else if (config.url.indexOf("sv2") > -1) {
        config.url = process.env.VUE_APP_STATIC_URL + config.url
      } else {
        config.url = window.location.origin + "/entry/" + config.url
      }
    } else {
      if (config.url.indexOf("//") === -1) {
        config.url = window.location.origin + "/" + config.url
      }
    }
    addSuffixForMobile(config)
    bigScreenDataFilter(config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 移动端请求加请求后缀
 * @param {*} config
 */
function addSuffixForMobile(config) {
  const keywords = ["rest-classify", "search-list", "/api-v2/chart", "/api-v2/detail", "/type/datas"]
  const isMatch = keywords.findIndex(word => config.url.indexOf(word) > -1) > -1
  if (isMatch) {
    const m = store.getters["operation/getActiveDevice"] || 0
    if (config.params) {
      config.params.m = m
    } else {
      if (config.url.indexOf("?") > -1) {
        config.url += "&m=" + m
      } else {
        config.url += "?m=" + m
      }
    }
  }
}

/**
 * 针对大屏页面进行数据过滤
 * @param config
 */
function bigScreenDataFilter(config) {
  // 根据当前路由获取对应的store
  // 去掉前面的斜杠
  if (!window.previewUrl) return
  if (window.previewUrl.indexOf("bigScreenPreview") === -1) return
  // 判断当前接口是否是请求数据的接口,如果是,根据store 给url拼接上uid和fid
  if (config.url.indexOf("api-v2/chart") !== -1 || config.url.indexOf("type/datas") !== -1) {
    const currentStore = store.state.bigScreen
    // 目前只针对大屏的页面进行该操作
    if (currentStore) {
      const { isFilterByUid, isFilterByFid } = currentStore.page
      // 如果当前页面需要根据uid或者fid过滤数据,则给url拼接上cookie中的uid和fid
      const uid = store.state.states.myCookie.UID
      const fid = store.state.states.myCookie.fid
      let sw = ""
      if (isFilterByUid && !isFilterByFid) sw = uid
      if (isFilterByFid && !isFilterByUid) sw = fid
      if (isFilterByUid && isFilterByFid) sw = uid + "###" + fid
      if (sw) {
        // 获取当前url中的参数
        const url = config.url
        const params = getParams(url)
        // 将sw参数拼接到url中, 如果url中已经有sw参数,则使用###进行拼接
        if (params.sw) {
          params.sw = params.sw + encodeURIComponent("###" + sw)
        } else {
          params.sw = encodeURIComponent(sw)
        }
        // 将params参数拼接到url中
        const paramsArr = []
        for (let key in params) {
          paramsArr.push(key + "=" + params[key])
        }
        config.url = url.split("?")[0] + "?" + paramsArr.join("&")
      }
    }
  }
}

/**
 * 获取url中的参数
 */
function getParams(url) {
  const params = {}
  const urlArr = url.split("?")
  if (urlArr.length > 1) {
    const paramsArr = urlArr[1].split("&")
    paramsArr.forEach(item => {
      const itemArr = item.split("=")
      params[itemArr[0]] = itemArr[1]
    })
  }
  return params
}

/**
 *
 * @param url
 * @param rawData
 * @param rawMethod
 * @param useFunc
 * @returns {{method: string, data: {}, url: *}}
 */
function handleParams(url, rawData, rawMethod, useFunc) {
  const method = rawMethod.toUpperCase()
  let data = {}
  if (useFunc === "params") {
    switch (method) {
      case "GET":
        data = { params: rawData }
        break
      case "POST":
        data = { params: rawData }
        break
    }
  } else if (useFunc === "data") {
    switch (method) {
      case "GET":
        data = { data: rawData }
        break
      case "POST":
        data = { data: qs.stringify(rawData) }
        break
    }
  } else if (useFunc === "body") {
    switch (method) {
      case "GET":
        data = { data: qs.stringify(rawData) }
        break
      case "POST":
        data = { data: rawData }
        break
    }
  }
  return {
    url,
    method,
    data
  }
}

export const fetchApi = (url, rawData = {}, method = "get", useFunc = "params") => {
  const options = handleParams(url, rawData, method, useFunc)
  return new Promise((resolve, reject) => {
    instance({
      url: options.url,
      method: options.method,
      ...options.data
    })
      .then(resp => {
        const res = resp
        if (url.indexOf("v2/svg") !== -1 && res.data) {
          // 针对svg接口进行特殊处理
          resolve(res)
          return
        }
        if (res.data.code === 1) {
          resolve(res)
        } else {
          res.message = getErrorMessage(res.data.message)
          reject(res)
        }
      })
      .catch(err => {
        err.message = getErrorMessage(err.data.message)
        reject(err)
      })
  })
}

export default instance
